import * as React from "react"
import Seo from "../components/seo"
import Hero from "../components/sections/book-library/Hero"
import HeroImage from "../components/sections/book-library/HeroImage"
import Explore from "../components/sections/book-library/Explore"
import BookList from "../components/sections/book-library/BookList"
import Follow from "../../src/components/sections/book-trailers/Follow"

import { Helmet } from "react-helmet"

const BookTrailerPage = () => (
  <>
    <Seo title="Writers Way Solutions Book library" />
    <Helmet bodyAttributes={{ class: "header-class" }} />
    <Hero/>
    <HeroImage />
    <BookList />
    <Explore />
    <Follow />
    {/* <NewsLetter/> */}
  </>
)

export default BookTrailerPage
